// extracted by mini-css-extract-plugin
export default {"component":"vitrineProductDialog__component___UfXgv"};